import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'semantic-ui-react'
import HeaderMenu from '../../components/header/headerMenu';

class Header extends Component {

    handleChange = (e, data) => {
        let signOut = data.value

        if( signOut === 'sign_out'){
            localStorage.removeItem('apiToken')
            localStorage.removeItem('userId')
            localStorage.removeItem('customerNo')
            localStorage.removeItem('realName')
            localStorage.removeItem('roleId')
            localStorage.removeItem('role')
            window.location.reload()

        }
    }

    render() {

        let headerOptions = [
            { key: 'account', text: 'Account', value: 'default' },
            { key: 'approval', text: 'Approval Condition', as: Link, to: '/approval-condition' },
            { key: 'sign-out', text: 'Sign Out', value: 'sign_out' },
        ]

        let headerOptions2 = [
            { key: 'account', text: 'Account', value: 'default' },
            { key: 'sign-out', text: 'Sign Out', value: 'sign_out' },
        ]

        return (
            <React.Fragment>
                <div className="navigationMenu">
                    <nav className="navbar navbar-expand-sm bg-white p-fixed-top w3-border-bottom">
                        {/* <span className="togButton"><i data-toggle="modal" data-target="#exampleModal1" className="fas fa-bars"></i>&nbsp;&nbsp;</span> */}
                        <Link className="icon_tracker" to="#"><img src="assets/svg/Sales.svg" width="25px" alt="scct icon" /><label style={{ color: "#006837", fontWeight: 700, letterSpacing: '0.5px' }}>&nbsp;&nbsp;Sales Platform </label></Link>
                        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navigation" aria-controls="navigation" aria-expanded="false" aria-label="Toggle navigation">
                            <i className="fas fa-ellipsis-v w3-text-black"></i>
                        </button>
                        <div className="collapse navbar-collapse justify-content-end" id="navigation" >
                            <HeaderMenu speedToken={localStorage.getItem('speedToken')} userKey={localStorage.getItem('userKey')} />
                            <Dropdown pointing="top right" className="nav-link" trigger={(
                                <span className="no-icon w3-small">Welcome, <b>{localStorage.getItem('realName')}</b></span>
                            )}
                                options={localStorage.getItem('roleId') === '2' || localStorage.getItem('roleId') === '1' ?
                            headerOptions : headerOptions2 }
                            onChange={this.handleChange}
                            />
                        </div>
                    </nav>
                </div>
            </React.Fragment>
        )
    }
}

export default Header;